import React from 'react'

import { Text } from 'components/typo'
import Link from 'components/shared/Link'
import Image from 'components/shared/Image'
import Separator from 'components/shared/Separator'

import classnames from 'classnames/bind'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const AuthorBlock = ({
  className,
  description,
  job = 'Software engineer @strapi',
  name,
  image,
  slug,
  coauthors,
}) => {
  return (
    <div className={cx(className, css.AuthorBlock)}>
      <Separator />
      <div className={css.wrapper}>
        {image && (
          <Image
            format="thumbnail"
            className={css.image}
            fluid
            {...image}
            alt=""
          />
        )}
        <div className={css.content}>
          {(name || job) && (
            <div className={css.smallDescription}>
              {name && (
                <Link href={`/user/${slug}`} style={{ textDecoration: 'none' }}>
                  <Text className={css.name} tag="div">
                    {name}
                  </Text>
                </Link>
              )}
              {job && (
                <Text
                  className={css.job}
                  theme="royal-blue"
                  size="small"
                  tag="div"
                >
                  {job}
                </Text>
              )}
            </div>
          )}
          {description && (
            <Text
              theme="chambray"
              tag="p"
              size="smaller"
              className={css.description}
            >
              {description}
            </Text>
          )}
        </div>
      </div>

      {coauthors?.length > 0 &&
        coauthors.map((author) => (
          <div className={css.wrapper} key={author.id}>
            {author.image && (
              <Image
                format="thumbnail"
                className={css.image}
                fluid
                {...author.image}
                alt=""
              />
            )}
            <div className={css.content}>
              {(author?.name || author?.job) && (
                <div className={css.smallDescription}>
                  {author?.name && (
                    <Link
                      href={`/user/${author?.slug}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <Text className={css.name} tag="div">
                        {author?.name}
                      </Text>
                    </Link>
                  )}
                  {author?.job && (
                    <Text
                      className={css.job}
                      theme="royal-blue"
                      size="small"
                      tag="div"
                    >
                      {author?.job}
                    </Text>
                  )}
                </div>
              )}
              {author?.description && (
                <Text
                  theme="chambray"
                  tag="p"
                  size="smaller"
                  className={css.description}
                >
                  {author?.description}
                </Text>
              )}
            </div>
          </div>
        ))}

      <Separator />
    </div>
  )
}

AuthorBlock.defaultProps = {}

export default AuthorBlock
